module.exports = __webpack_public_path__ + "static/img/2.e0f0348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hezuo/2.png
// module id = NUz3
// module chunks = 1